/* Two jobs:
   1. Light the active dot from the scroll position (motion itself is native scroll-snap).
   2. Inside a horizontal product rail (<slider-element>), shrink the swipe track to the
      painted width of the image so the letterbox margins fall OUTSIDE it. A swipe on the
      photo flips images; a swipe on the margin/gap passes through to the rail and moves to
      the next product. In vertical grids (no rail) the track stays full-width. */
class MobileCardGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;

    if (this.closest('slider-element')) {
      this._first = this.querySelector('.pc-swipe__img');
      if (this._first) {
        const fit = () => this.fitToImage();
        if (this._first.complete) fit();
        else this._first.addEventListener('load', fit, { once: true });
        this._onResize = () => {
          clearTimeout(this._rt);
          this._rt = setTimeout(fit, 150);
        };
        window.addEventListener('resize', this._onResize, { passive: true });
      }
    }

    this.dots = this.querySelectorAll('[data-dots] .pc-swipe__dot');
    if (this.dots.length < 2) return;

    this._raf = 0;
    this.track.addEventListener(
      'scroll',
      () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          const w = this.track.clientWidth;
          if (!w) return;
          const i = Math.round(this.track.scrollLeft / w);
          this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        });
      },
      { passive: true }
    );
  }

  fitToImage() {
    const natW = this._first.naturalWidth;
    const natH = this._first.naturalHeight;
    if (!natW || !natH) return;
    // Measure the natural (un-narrowed) box first.
    this.classList.remove('pc-swipe--fit');
    const boxW = this.clientWidth;
    const boxH = this.clientHeight;
    if (!boxW || !boxH) return;
    const painted = Math.min(boxW, (boxH * natW) / natH);
    if (painted < boxW - 2) {
      this.style.setProperty('--pc-w', Math.round(painted) + 'px');
      this.style.setProperty('--pc-h', Math.round(boxH) + 'px');
      this.classList.add('pc-swipe--fit');
    } else {
      this.style.removeProperty('--pc-w');
      this.style.removeProperty('--pc-h');
    }
  }

  disconnectedCallback() {
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  }
}

if (!customElements.get('mobile-card-gallery')) {
  customElements.define('mobile-card-gallery', MobileCardGallery);
}
